<div class="select-dropdown-big select-dp-c" [formGroup]="form">
  <label [for]="settings.idName" [ngClass]="{ 'text-danger': errorMessage }">
    {{ settings.label }}
  </label>
  <tooltip [title]="settings.label" placement="right" delay="200"></tooltip>

  <select
    [id]="settings.idName"
    [name]="settings.name"
    [class]="settings.className"
    [ngClass]="{ 'border-danger': errorMessage }"
    [formControlName]="settings.formControlName"
    (change)="valueChange()"
    (focus)="onFocusEvent($event)"
    (click)="onClickEvent($event)"
    (blur)="onBlurEvent($event)"
  >
    <option disabled value="">{{ settings.placeholder }}</option>
    <option *ngFor="let v of settings.innerelements" value="{{ v.value }}">{{
      v.label
    }}</option>
  </select>
</div>
<p class="text-danger" *ngIf="errorMessage">{{ errorMessage }}</p>
